export function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
//# sourceMappingURL=errorHandling.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-apollo/node_modules/apollo-client/util/errorHandling.js
// module id = 469
// module chunks = 0